import { Check } from 'lucide-react'
import { siteText } from '../siteText'
import type { Clip, Version } from '../types'

/** Only label the exact version whose approval is still recorded. */
export function ApprovalAttribution({ clip, version }: { clip: Clip; version: Version | null | undefined }) {
  if (!version) return null
  const final = version.kind === 'final'
  const approvedId = final ? clip.final_approved_version_id : clip.approved_version_id
  const actor = final ? clip.final_approved_by : clip.reviewed_by
  const at = final ? clip.final_approved_at : clip.reviewed_at
  if (approvedId !== version.id || !actor?.name) return null
  return <p className="approval-attribution"><span className="approval-check" aria-hidden="true"><Check size={11} strokeWidth={2.5} /></span><span>{siteText(`Approved by ${actor.name}`)}</span>{at ? <time className="sr-only" dateTime={at}>{siteText(new Date(at).toLocaleString())}</time> : null}</p>
}
